import React, { useState } from "react";
import { observer } from "mobx-react";
import { zohoDataStore } from "./ZohoStoreData";
import VariantToggle from "Pages/Dashboard/sequences/SequencePage/VariantToggle";

const ActivityTab = observer(() => {
  const [badgeIndex, setBadgeIndex] = useState("");

  const activityCheckList = [
    {
      key: "emailSent",
      id: "emailSent",
      value: zohoDataStore?.zohoPreferences?.syncSentEnabled,
      text: "Email sent"
    },
    {
      key: "emailOpened",
      id: "emailOpened",
      value: zohoDataStore?.zohoPreferences?.syncOpenEnabled,
      text: "Email opened"
    },
    {
      key: "emailReplied",
      id: "emailReplied",
      value: zohoDataStore?.zohoPreferences?.syncReplyEnabled,
      text: "Email replied"
    },
    {
      key: "emailClicked",
      id: "emailClicked",
      value: zohoDataStore?.zohoPreferences?.syncClickEnabled,
      text: "Link clicked in an email"
    },
    {
      key: "phoneCall",
      id: "phoneCall",
      value: zohoDataStore?.zohoPreferences?.syncPhoneCallEnabled,
      text: "Phone calls"
    },
    {
      key: "liRequestSent",
      id: "liRequestSent",
      value: zohoDataStore?.zohoPreferences?.syncLiSendRequest,
      text: "LinkedIn connection request sent"
    },
    {
      key: "liRequestAccepted",
      id: "liRequestAccepted",
      value: zohoDataStore?.zohoPreferences?.syncLiAcceptRequest,
      text: "LinkedIn connection request accepted"
    },
    {
      key: "liMessageSent",
      id: "liMessageSent",
      value: zohoDataStore?.zohoPreferences?.syncLiMessageSent,
      text: "LinkedIn message sent"
    },
    {
      key: "liMessageReceived",
      id: "liMessageReceived",
      value: zohoDataStore?.zohoPreferences?.syncLiReplyReceived,
      text: "LinkedIn reply received"
    },
    {
      key: "customTask",
      id: "customTask",
      value: zohoDataStore?.zohoPreferences?.syncCustomTask,
      text: "Custom Task"
    }
  ];

  const zohoPreferencesMap = {
    phoneCall: "syncPhoneCallEnabled",
    emailSent: "syncSentEnabled",
    emailOpened: "syncOpenEnabled",
    emailReplied: "syncReplyEnabled",
    emailClicked: "syncClickEnabled",
    liRequestSent: "syncLiSendRequest",
    liRequestAccepted: "syncLiAcceptRequest",
    liMessageSent: "syncLiMessageSent",
    liMessageReceived: "syncLiReplyReceived",
    customTask: "syncCustomTask"
  };

  const setCheckedValue = (e, value, id) => {
    const propertyName = zohoPreferencesMap[id];
    if (propertyName) {
      zohoDataStore.setZohoPreferences({
        ...zohoDataStore?.zohoPreferences,
        [propertyName]: value
      });
    }
  };

  return (
    <div className="activityWrapper">
      <h5 className="headingText">Activity Logging</h5>
      <p className="descText">
        Select the events that you want to log to your Zoho CRM
      </p>
      <div className="checkListBox">
        {activityCheckList?.length &&
          activityCheckList?.map((item, index) => {
            const { id = "", text = "", value = "", disabled = false } = item;
            return (
              <div
                key={`${id}-${text}`}
                className="activityCheckListWrapper"
                onMouseEnter={() => setBadgeIndex(index)}
                onMouseLeave={() => setBadgeIndex("")}
              >
                <div
                  className={`variantToggleWrapper ${
                    disabled ? "disabled" : ""
                  }`}
                >
                  <VariantToggle
                    action={setCheckedValue}
                    isChecked={value}
                    id={id}
                  />
                  <span className="toggleText">{text}</span>
                </div>
                {badgeIndex === index && disabled && (
                  <span
                    className="comingSoonBadge"
                    style={{ display: "block" }}
                  >
                    Coming Soon
                  </span>
                )}
              </div>
            );
          })}
      </div>
    </div>
  );
});

export { ActivityTab };
export default ActivityTab;
